var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg824",
    width: 33.279999,
    height: 30.08,
    viewBox: "0 0 33.279999 30.08",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.018919,8.1174856 1.8109427,28.236158 H 31.448906 L 27.21544,21.71832 m -3.25127,-5.054152 -2.32704,-3.800577",
    stroke: "#cc214f",
    strokeWidth: 4.11788,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path948-5",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#c00000",
      strokeWidth: 3.62217,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.739124,4.5318516 c 0,2.5028176 -2.031752,4.531852 -4.537923,4.531852 -2.50617,0 -4.537924,-2.0290344 -4.537924,-4.531852 C 11.663277,2.029034 13.695031,0 16.201201,0 c 2.506171,0 4.537923,2.029034 4.537923,4.5318516 z m -5.871798,0 c 0,0.7356699 0.59722,1.3320893 1.333875,1.3320893 0.736657,0 1.333874,-0.5964194 1.333874,-1.3320893 0,-0.7356713 -0.597217,-1.3320892 -1.333874,-1.3320892 -0.736655,0 -1.333875,0.5964179 -1.333875,1.3320892 z",
    fill: "#0f2426",
    id: "path950-4",
    style: {
      display: "inline",
      fill: "#c00000",
      fillOpacity: 1,
      strokeWidth: 0.137421
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.a384414e392a0e971c3d64faa77119f6.svg";
export { ForwardRef as ReactComponent };